import { render } from "./footer-two.vue?vue&type=template&id=2a80d26f&scoped=true"
const script = {}

import "./footer-two.vue?vue&type=style&index=0&id=2a80d26f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a80d26f"]])

export default __exports__